
let styles = {
    container: {
      padding: '0 0 24px 0',
      display: 'flex',
      justifyContent: 'center',
    },
    // The form card
    table: {
        backgroundColor: 'white',
        padding: '0',
        borderRadius: '12px',
        border: '1px solid #e6e9f0',
        boxShadow: '0 1px 3px rgba(16,24,40,0.06)',
        overflow: 'hidden',
    },
    // One label / field row
    items: {
        padding: '12px 24px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '16px',
        borderBottom: '1px solid #eef1f6',
    },

    item_header: {
        fontWeight: 600,
        fontSize: '14px',
        color: '#1f2d3d',
        paddingLeft: '0',
        width: '35%',
        flex: 'none',
    },
     item_images: {
        fontWeight: 600,
        padding: '0',
        width: '65%',
    },

    // selects
    item_body: {
        padding: '0 10px',
        minHeight: '38px',
        width: '65%',
        border: '1px solid #d6dde8',
        borderRadius: '8px',
        background: 'white',
        fontSize: '14px',
    },

    main_header: {
        padding: '18px 24px',
        color: 'white',
        margin: '0',
        backgroundColor: '#115691',
        borderRadius: '0',
    },

    input: {
        width: '65%',
        height: 38,
        padding: '0 12px',
        border: '1px solid #d6dde8',
        borderRadius: '8px',
        fontSize: '14px',
      },

    court_list: {
        padding: '1%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'space-around',
        borderBottom: '1px solid black',
    },
    button_submit: {
        padding: '24px',
        justifyContent: 'center',
        display: 'flex',
    },

    textbox: {
        width: '65%',
        height: 80,
        padding: '8px 12px',
        border: '1px solid #d6dde8',
        borderRadius: '8px',
        fontSize: '14px',
        resize: 'vertical',
      },

    // Wraps a react-times TimePicker so it sits in the field column like the
    // other inputs.
    timeRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        width: '65%',
    },
    timeField: {
        width: '200px',
    },
    timeCaption: {
        fontSize: '12px',
        fontWeight: 600,
        color: '#6b7a90',
        marginBottom: '4px',
    },

    backBtn: {
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        border: '1px solid #cfd8e6',
        background: 'white',
        color: '#115691',
        margin: '16px 0 12px 0',
    },
    formTitle: {
        margin: 0,
        fontSize: '22px',
        fontWeight: 700,
        textAlign: 'left',
        color: 'white',
        opacity: 1,
    },
    submitBtn: {
        border: 'none',
        borderRadius: '8px',
        padding: '10px 32px',
        fontSize: '15px',
        fontWeight: 600,
        color: 'white',
    },

    message: {
        fontSize: '120%',
        fontWeight: 600,
        textAlign: 'center'
    },
    imageHint: {
        fontWeight: 400,
        fontSize: '12px',
        color: '#6c757d',
        marginTop: '4px'
    },
    imageGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px',
        marginTop: '8px'
    },
    imageTile: {
        position: 'relative',
        width: 'fit-content'
    },
    imageThumb: {
        objectFit: 'cover',
        borderRadius: '4px',
        border: '1px solid #dee2e6'
    },
    coverBadge: {
        position: 'absolute',
        left: '4px',
        bottom: '4px',
        padding: '1px 6px',
        fontSize: '11px',
        color: '#fff',
        backgroundColor: 'rgba(0,0,0,0.6)',
        borderRadius: '3px'
    },
    deleteImgBtn: {
        border:'none',
        borderRadius:'50%',
        position:'absolute',
        top:'0',
        right:'-8px',
        backgroundColor:'#dc3545',

    },

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/editVenue/style.js